import { Alert, AlertTitle, Button } from '@mui/material';
import { DateTime } from 'luxon';
import { BulkActivationResultItemDTO } from 'probonio-shared-ui/api';
import { useTranslation } from 'react-i18next';
import { BasicDialog, DialogState } from '../../../component/dialog';
import { useBenefitContext } from '../BenefitContext';

interface Props {
  dialogState: DialogState;
  variant: 'deactivate' | 'pause';
  result: BulkActivationResultItemDTO;
}

export const SingleActivationResultDialog: React.FC<Props> = ({ dialogState, variant, result }) => {
  const { t } = useTranslation('benefitsModule');
  const { benefit } = useBenefitContext();
  const isBlocked = result.status === 'BLOCKED';
  const resultDialogKey = variant === 'pause' ? 'pauseResultDialog' : isBlocked ? 'deactivateBlockedDialog' : 'deactivateResultDialog';
  const variantKey = `editDialog.${resultDialogKey}`;
  const title = t([`${benefit}.${variantKey}.title`, `${variantKey}.title`]);
  const message = t([`${benefit}.${variantKey}.message`, `${variantKey}.message`], {
    date: result.endDate ? DateTime.fromISO(result.endDate) : undefined,
  });

  return (
    <BasicDialog
      dialogState={dialogState}
      title={title}
      content={
        <Alert severity={variant === 'pause' || isBlocked ? 'error' : 'warning'}>
          <AlertTitle>{t('editDialog.resultMessageTitle')}</AlertTitle>
          {message}
        </Alert>
      }
      actions={
        <Button type="button" variant="contained" onClick={dialogState.handleClose}>
          {t('common:buttons.close')}
        </Button>
      }
    />
  );
};
